<template>
  <!-- 添加一个组页面 -->
  <!-- 设置页面的内容区域 -->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->
      <config-title-hang class="config_hight_change">
        <span slot="config_title_hang_ele4">右击可删除一条规则</span>
        <img slot="config_title_hang_ele3"
             src="~assets/img/config/tishilaba.png"
             alt />
      </config-title-hang>

      <config-hang @click.native="selectSenceObject">
        <span slot="config_hang_ele2">选择组关联的对象</span>
        <img slot="config_hang_ele4"
             src="~assets/img/config/youjiantou.png"
             alt />
      </config-hang>

      <config-title-hang>
        <span slot="config_title_hang_ele2">组规则列表</span>
      </config-title-hang>
      <!-- ////下拉选择框 -->
      <div class="select_scene_rule_wraper">
        <user-select :selectData="selectData"
                     @selectValueEvent="selectValueEvent"></user-select>
      </div>

      <!-- 对服务器传来的规则数组进行遍历显示 -->
      <!-- key值加上时间戳保证唯一性，避免出现问题 -->
      <!-- <config-rule-hang v-for="(value, index) in ServeGroupRule"
                        :key="index + new Date().getTime()"
                        :oneRule="ServeGroupRule[index]"
                        :ServeGroupRuleListIndex="index"
                        @contextmenu.prevent.native="oneRuleRightClickBtnHandle(value, index)"></config-rule-hang> -->

      <config-hang v-for="(value, index) in ServeGroupRule"
                   :key="index"
                   @click.native="configHangSelectGroupObjectBtnHandle(value)"
                   @contextmenu.prevent.native="oneRuleRightClickBtnHandle(value ,index )">
        <span slot="config_hang_ele2">{{value.remark}}({{value.regionName}})</span>
      </config-hang>

      <div class="xiaotishi_style">小提示：保存组时，子账号尽量不要控制设备，否则可能出现保存组失败的情况~。</div>

      <div class="public_config_que_ren_btn"
           @click="configQueRenBtn">
        保存并返回
      </div>
    </div>
  </div>
</template>

<script>
import configHang from 'components/common/config/config-hang'
import configTitleHang from 'components/common/config/config-title-hang'
import configRuleHang from 'components/common/config/config-rule-hang'
import UserSelect from 'components/common/select/user-select'
export default {
  data () {
    return {
      OneGroupinfo: {
        ////虚拟的一个组信息，实际在页面加载过程中指向了仓库的存的当前组
        deleteState: 1,
        followState: null,
        iconId: '',
        iconUrl: '',
        regionId: '',
        regionName: '请选择一个区域',
        deviceId: '',
        deviceName: '',
        sceneNo: null
      },
      ServeGroupRule: [
        ////  服务器请求到的一个组的规则列表
      ],
      checkDeviceList: [], /////选中设备的list，需要存到仓库实时更新
      selectData: {
        ////下拉选择框的数据
        tableData: [
          {
            name: '名称排序'
          }
        ],
        value: '默认排序'
      }
    }
  },
  computed: {
    computerGroupIconSrc () {
      ////计算选择区域图片应该显示的按钮
      // console.log(this.OneGroupinfo.iconUrl);
      if (this.OneGroupinfo.iconUrl === '') {
        ///动态绑定图片 需要require
        return require('assets/img/config/xuanimg.png')
      } else {
        ////动态绑定http的url  不需要require
        return this.OneGroupinfo.iconUrl
      }
    }
  },
  components: {
    configHang,
    configTitleHang,
    configRuleHang,
    UserSelect
  },
  methods: {
    configQueRenBtn () {
      // 组规则的保存并返回按钮按下了
      // 提交服务器之前对数据进行检查
      if (this.ServeGroupRule.length === 0) {
        this.$toast('请至少创建一条规则再保存！')
        return
      }

      // 保存组规则到服务器 兼容组接口修改,组接口只需要提供设备id
      // let groupDeviceList = [];
      // for (let i = 0; i < this.ServeGroupRule.length; i++) {
      //   groupDeviceList.push(this.ServeGroupRule[i].deviceId)
      // }

      /////保存下载组规则到服务器及底层
      let requestGroupTimeout = this.ServeGroupRule.length * 600 + 6000 ////组规则下载超时时间的计算 //代号20220907-1
      console.log(requestGroupTimeout)
      console.log(this.ServeGroupRule)
      console.log(this.OneGroupinfo)

      this.$store.dispatch('asyUpdataRequestSceneTimeout', requestGroupTimeout) ///异步提交组超时时间到仓库
      this.$requestSceneRule({
        method: 'post',
        url: '/userGroup/saveGroupRuleList',
        timeout: requestGroupTimeout,
        data: {
          token: this.$store.state.token,
          deviceId: this.OneGroupinfo.deviceId,
          ruleList: this.ServeGroupRule
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            console.log(res.data)

            this.$showTipsToast(3, res.data.message)
            ////说明信息填写错误,控制失败了，
            return
          } else {
            ////、控制成功了
            console.log(res.data)
            // this.OneGroupinfo.deviceId = res.data.data.deviceId; ////拿到服务器返回的数据结果 组id

            if (res.data.data.length === 0) {
              this.$showTipsToast(1, '保存组成功！', true) ////提示框
              this.$router.go(-2)
            } else {
              this.$showTipsToast(7, res.data.data)
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    selectSenceObject () {
      console.log(this.ServeGroupRule)
      console.log(this.ServeGroupRule.length)
      this.checkDeviceList.length = 0 ////清空设备ID数组
      for (let i = 0; i < this.ServeGroupRule.length; i++) {
        this.checkDeviceList[i] = this.ServeGroupRule[i].deviceId
      }
      ////数组去重
      console.log(this.checkDeviceList)

      this.checkDeviceList = Array.from(new Set(this.checkDeviceList))
      // ServeGroupRule
      this.$store.dispatch('asyUpdataCheckDeviceList', this.checkDeviceList) ///异步提交选中的设备ID到仓库
      ///获取组规则对象列表
      console.log(this.checkDeviceList)
      this.$request({
        method: 'post',
        url: '/userGroup/findGroupDeviceList',
        data: {
          token: this.$store.state.token,
          deviceId: this.OneGroupinfo.deviceId,
          checkDeviceList: this.checkDeviceList, ///传入当前页面的规则 对象id，需要去重
          regionIds: [] ///传入要筛选的区域列表，空的话代表所有区域
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message)
            ////说明信息填写错误,控制失败了，
            return
          } else {
            ////、控制成功了
            console.log(res.data)
            this.$store.dispatch(
              'asyUpdataOneGroupRuleObjectRegionList',
              res.data.data
            ) ///同步服务器拿到的数据到仓库，同步的是地址

            this.$router.push('ConfigSelectGroupObject')
            // this.OneGroupinfo.deviceId = res.data.data.deviceId; ////拿到服务器返回的数据结果 组id  存到仓库
            // this.$showTipsToast(1, "获取成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getTypeSelected () {
      //获取select 下拉框选中的值
      console.log(this.selected)
    },
    selectValueEvent (value) {
      ///下拉选择框传来的值
      // 对规则列表就行排序  一旦进行时间排序或名称排序  由于逻辑问题默认排序将不可恢复
      this.selectData.value = value
      console.log(this.selectData.value)
      if (this.selectData.value === this.selectData.tableData[0].name) {
        ///名称正序排序
        // console.log(
        this.ServeGroupRule.sort(function (a, b) {
          return (a.regionName + a.remark).localeCompare(
            b.regionName + b.remark,
            'zh'
          ) ///按照拼音排序
        })
        // )
      }

      // console.log(this.selectData.value)
    },
    oneRuleRightClickBtnHandle (value, index) {
      this.$showTipsToast(22, value, false, 1000, index)
    }
  },
  mounted () {
    console.log('mounted阶段')
  },
  created () {
    console.log('created阶段')

    //// 把仓库的一个组信息的地址拿过来  拿的是地址  并不是数据
    this.OneGroupinfo = this.$store.state.configinfo.OneGroupinfo
    ///把仓库存储的 一条组信息的规则（服务端实时请求到的） 地址从仓库拿过来
    // console.log(this.$store.state.configinfo.OneGroupRuleList);
    this.ServeGroupRule = this.$store.state.configinfo.OneGroupRuleList
    ///把仓库存储的 一条组信息的勾选对象地址拿过来
    // console.log(this.$store.state.configinfo.OneGroupRuleList);
    this.checkDeviceList = this.$store.state.configinfo.checkDeviceList
  }
}
</script>

<style>
/* 提示title的公共样式 */
.config_title_hang_wraper.config_hight_change {
  height: 40px;
  line-height: 40px;
}
.config_hight_change img {
  right: 180px;
}
.select_scene_rule_wraper {
  position: absolute;
  top: 105px;
  right: 50px;
  /* background: transparent; */
}
</style>
